import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
// import TextField from '@mui/material/TextField'
import { useTranslation } from 'react-i18next'
import TextField from './TextField'

function NumberField(props: any) {
  const { value, name, onChange, setValid, ...rest } = props
  const { t } = useTranslation('numberField')
  const [error, setError] = useState('')
  const [initial, setInitial] = useState(true)
  const { from, to }: any = t('decimalSeparator', { returnObjects: true })

  useEffect(() => {
    if (initial) {
      setInitial(false)
      return
    }
    if (value.length === 0) {
      setError(t('noNumber'))
      setValid(false)
      return
    }
    const numberRegex = /^([0-9]*)[.,]?([0-9]*)$/igm
    if (!numberRegex.test(value)) {
      setError(t('noValidNumber'))
      setValid(false)
      return
    }
    setValid(true)
    setError('')
  }, [t, value])
  return (
    <TextField
      t={t}
      type="number"
      error={error}
      value={String(value)}
      onChange={(val) => {
        if (/^([0-9]*)[.,]?([0-9]*)$/igm.test(val)) {
          // locality parsing
          const replacedVal = val.replace(from, to)
          const number = parseFloat(replacedVal)
          onChange(number)
        }
      }}
      name={name}
      {...rest}
    />
  )
}

NumberField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  setValid: PropTypes.func.isRequired,
}

export default NumberField
